/**
 * 政府端 — 证照核验（检疫调运单 A/B 证）
 */
import { useEffect, useState } from 'react';
import { fetchOrders, fetchQuarantine } from '@/api/transit';
import { Empty, Loading, PageHeader, StatusTag } from '@/components/common';
import type { QuarantineCert, TransitOrder } from '@/types';
import { certTypeText, certVerifyText, fmtTime } from '@/utils/format';

export default function GovQuarantine() {
  const [orders, setOrders] = useState<TransitOrder[]>([]);
  const [certs, setCerts] = useState<Record<number, QuarantineCert[]>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrders({ page_size: 100 }).then(async (d) => {
      setOrders(d.list);
      const map: Record<number, QuarantineCert[]> = {};
      for (const o of d.list) {
        map[o.id] = await fetchQuarantine(o.id);
      }
      setCerts(map);
      setLoading(false);
    });
  }, []);

  if (loading) return <Loading />;

  const allCerts = orders.flatMap((o) => (certs[o.id] ?? []).map((c) => ({ ...c, transit_no: o.transit_no })));

  return (
    <div>
      <PageHeader title="证照核验" sub="检疫调运单（A证/B证）上传与核验状态" />
      <div className="card">
        {allCerts.length === 0 ? (
          <Empty text="暂无证照记录" />
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>运输单号</th>
                <th>证照类型</th>
                <th>证号</th>
                <th>关联牛只</th>
                <th>核验状态</th>
                <th>核验结果</th>
                <th>上传时间</th>
              </tr>
            </thead>
            <tbody>
              {allCerts.map((c) => (
                <tr key={c.id}>
                  <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{c.transit_no}</td>
                  <td>{certTypeText(c.cert_type)}</td>
                  <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{c.cert_no}</td>
                  <td>{c.cattle_count} 头</td>
                  <td>
                    <StatusTag tone={c.verify_status === 1 ? 'green' : c.verify_status === 2 ? 'red' : c.verify_status === 3 ? 'amber' : 'muted'}>
                      {certVerifyText(c.verify_status)}
                    </StatusTag>
                  </td>
                  <td style={{ maxWidth: 320 }}>{c.verify_result || '—'}</td>
                  <td style={{ fontSize: 12, color: 'var(--color-ink-secondary)' }}>{fmtTime(c.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
